import { useCallback, useRef, useState } from 'react'
import { catalog } from 'virtual:kayd-catalog'
import { Catalog } from './components/Catalog'
import { PREVIEWS_ENABLED } from './config'
import { usePrefersReducedMotion, useWebGLAvailable } from './hooks/useEnvironment'
import { usePreviewLayer } from './hooks/usePreviewLayer'

const YEAR_RANGE = '2025-2026'

export function App() {
  const root = useRef<HTMLDivElement>(null)
  const reducedMotion = usePrefersReducedMotion()
  const webgl = useWebGLAvailable()

  // One renderer for every plate. A canvas per plate would exhaust the browser's
  // WebGL context limit somewhere past the eighth game.
  //
  // Reduced motion does not suppress the previews, it freezes them. The
  // preference is about movement, so a still scene honours it while a blank
  // frame would just discard the content.
  const layer = usePreviewLayer(PREVIEWS_ENABLED && webgl)
  const [stageReady, setStageReady] = useState(false)
  const onStageReady = useCallback(() => setStageReady(true), [])

  return (
    <div ref={root}>
      <a className="skip-link" href="#catalog">
        Skip to the games
      </a>

      <div className="shell">
        <header className="masthead">
          <h1 className="wordmark">
            kayd<span className="dot">.</span>fun
          </h1>
          <p className="masthead__note">
            Games by Kayd Hendricks. They run in a browser, nothing to install.
          </p>
        </header>

        <main>
          <Catalog
            games={catalog}
            GameView={layer?.GameView}
            stageReady={stageReady}
            animate={!reducedMotion}
            showMedia={PREVIEWS_ENABLED}
          />
        </main>

        <footer className="colophon">
          <span>&copy; Kayd Hendricks {YEAR_RANGE}</span>
          <span>{catalog.length} published</span>
        </footer>
      </div>

      {layer ? <layer.Stage eventSource={root} onReady={onStageReady} /> : null}
    </div>
  )
}
